import { PieChart, Pie, Cell } from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import {
  ChartContainer,
} from "../ui/chart";

export const description = "Melody Statistics";

export function MelodyCounter(props) {

  const chartConfig = {
    visitors: {
      label: "Visitors",
    },
    chrome: {
      label: "mel1",
      color: "hsl(var(--chart-1))",
    },
    safari: {
      label: "mel2",
      color: "hsl(var(--chart-2))",
    },
    firefox: {
      label: "mel3",
      color: "hsl(var(--chart-3))",
    },
    edge: {
      label: "mel4",
      color: "hsl(var(--chart-4))",
    },
    other: {
      label: "mel5",
      color: "hsl(var(--chart-5))",
    },
  };

  const pieData = [
    {
      name: chartConfig.chrome.label,
      value: props?.melody?.["1"] ?? 0,
      fill: chartConfig.chrome.color,
    },
    {
      name: chartConfig.safari.label,
      value: props?.melody?.["2"] ?? 0,
      fill: chartConfig.safari.color,
    },
    {
      name: chartConfig.firefox.label,
      value: props?.melody?.["3"] ?? 0,
      fill: chartConfig.firefox.color,
    },
  ];

  // No melodies played in the selected period: show a message instead of an empty pie
  const hasData = pieData.some((entry) => entry.value > 0);

  return (
    <Card className="flex flex-col min-h-[450px] max-h-[450px] w-full min-w-0 items-center">
      <CardHeader className="flex flex-col items-center pb-0 text-center">
        <CardTitle className="whitespace-normal break-words">Melody Count</CardTitle>
        <CardDescription>Selected period</CardDescription>
      </CardHeader>
      <CardContent className="flex-1 w-full min-w-0 pb-0 items-center ">
        {!hasData ? (
          <div className="flex h-full min-h-[240px] flex-col items-center justify-center gap-1 text-center">
            <p className="text-xl font-semibold text-muted-foreground">No data</p>
            <p className="text-sm text-muted-foreground">No melodies were played in the selected period</p>
          </div>
        ) : (
        <ChartContainer
          config={chartConfig}
          className="mx-auto aspect-square w-full max-h-[400px] min-h-[240px] "
        >
          <PieChart width={400} height={400} className=" items-center mr-2">
          <Pie
            data={pieData}
            cx="50%"
            cy="50%"
            outerRadius="60%"
            dataKey="value"
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          >
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Pie>
        </PieChart>
        </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
}